<div (mouseover)="hover=true" (mouseleave)="hover=false" class="dashboard-item" pRipple class="dashboard-item" (click)="itemClickFunc(this.link)"
[ngStyle]="{'backgroundColor':hover?hoverColor:backgroundColor,'width':widthItem,'height':heightItem}">
        <img *ngIf="imageLink!=''" src="{{imageLink}}" width="32" height="32" />
        <p>{{title}}</p>
</div>